import { UserManager, WebStorageStateStore } from "oidc-client";

export default class AuthService {
  constructor() {}

  async initialize() {
    var config = await (await fetch("static/config.json")).json();

    const settings = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: config.auth_authority,
      client_id: config.auth_client_id,
      client_secret: config.auth_client_secret,
      redirect_uri: config.auth_redirect_base_url + "callback.html",
      silent_redirect_uri: config.auth_redirect_base_url + "silent-renew.html",
      post_logout_redirect_uri: config.auth_redirect_base_url,
      response_type: "code",
      scope: "openid profile AppFramework offline_access",
      filterProtocolClaims: true,
      loadUserInfo: true,
      automaticSilentRenew: true,
      allowAccessTokensViaBrowser: true
    };

    this.userManager = new UserManager(settings);
    this.userManager.events.addSilentRenewError((e) => {
      console.log("Failed to renew token error: " + e);
    });
  }

  static async create() {
    const authService = new AuthService();
    await authService.initialize();
    return authService;
  }

  silentRenew() {
    this.userManager.signinSilent().then(function() {});
  }
  getUser() {
    return this.userManager.getUser();
  }
  login() {
    return this.userManager.signinRedirect();
  }
  logout() {
    return this.userManager.signoutRedirect();
  }
  async getAccessToken() {
    var user = await this.getUser();
    return user.access_token;
  }
}
